
// actionType:
// -- detail
// -- add
// -- remove
// -- purchase

export default ( props, inject ) => {
  const vkGoalWr = function (actionGoal) {
    window._tmr = window._tmr || (window._tmr = []);
    _tmr.push({
      type: "reachGoal",
      id: 3317020,
      goal: actionGoal
    })
  }

  return inject("vkGoalWr", vkGoalWr)
}
